import React, { useState, useEffect } from "react";
import Layout from "../Components/Layout";
import axios from "axios";
import { Accordion } from "react-bootstrap";

const MyProfile = ({ children }) => {
  const [profileData, setProfileData] = useState({
    empId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    personalMailId: "",
    companyMailId: "",
    mobile: "",
    role: [],
    dateOfBirth: "",
    dateOfJoining: "",
    department: "",
    designation: "",
    managerName: "",
    hrName: "",
    photo: "",
  });

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/employees/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setProfileData(response.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData({
      ...profileData,
      [name]: value,
    });
  };

  const handleSaveChanges = async () => {
    try {
      const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/v1/employees/profile`, profileData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      alert("Profile updated successfully!");
      console.log("Updated Profile Data:", response.data);
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile. Please try again.");
    }
  };

  return (
    <Layout children={children}>
      <div className="container my-5">
        <div className="card shadow">
          <div className="card-header bg-primary text-white text-center">
            <h3>My Profile</h3>
          </div>
          <div className="card-body">
            <form>
              {/* Profile Information Section */}
              <div className="mb-4">
                <h5>Profile Information</h5>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label htmlFor="firstName" className="form-label">
                      First Name
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={profileData.firstName}
                      className="form-control"
                      placeholder="Enter your first name"
                      disabled
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="middleName" className="form-label">
                      Middle Name
                    </label>
                    <input
                      type="text"
                      id="middleName"
                      name="middleName"
                      value={profileData.middleName}
                      className="form-control"
                      placeholder="Enter your middle name"
                      disabled
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="lastName" className="form-label">
                      Last Name
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={profileData.lastName}
                      className="form-control"
                      placeholder="Enter your last name"
                      disabled
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label htmlFor="personalMailId" className="form-label">
                      Personal Email
                    </label>
                    <input
                      type="email"
                      id="personalMailId"
                      name="personalMailId"
                      value={profileData.personalMailId}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter your personal email"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="companyMailId" className="form-label">
                      Company Email
                    </label>
                    <input
                      type="email"
                      id="companyMailId"
                      name="companyMailId"
                      value={profileData.companyMailId}
                      className="form-control"
                      placeholder="Enter your company email"
                      disabled
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="mobile" className="form-label">
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      id="mobile"
                      name="mobile"
                      value={profileData.mobile}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter your mobile number"
                    />
                  </div>
                </div>
              </div>

              {/* Additional Details Section */}
              <Accordion className="mb-4">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Additional Details</Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label htmlFor="dateOfBirth" className="form-label">
                          Date of Birth
                        </label>
                        <input
                          type="date"
                          id="dateOfBirth"
                          name="dateOfBirth"
                          value={profileData.dateOfBirth}
                          className="form-control"
                          disabled
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="dateOfJoining" className="form-label">
                          Date of Joining
                        </label>
                        <input
                          type="date"
                          id="dateOfJoining"
                          name="dateOfJoining"
                          value={profileData.dateOfJoining}
                          className="form-control"
                          disabled
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="department" className="form-label">
                          Department
                        </label>
                        <input
                          type="text"
                          id="department"
                          name="department"
                          value={profileData.department}
                          className="form-control"
                          placeholder="Enter your department"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label htmlFor="designation" className="form-label">
                          Designation
                        </label>
                        <input
                          type="text"
                          id="designation"
                          name="designation"
                          value={profileData.designation}
                          className="form-control"
                          placeholder="Enter your designation"
                          disabled
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="managerName" className="form-label">
                          Manager Name
                        </label>
                        <input
                          type="text"
                          id="managerName"
                          name="managerName"
                          value={profileData.managerName}
                          className="form-control"
                          placeholder="Enter your manager's name"
                          disabled
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="hrName" className="form-label">
                          HR Name
                        </label>
                        <input
                          type="text"
                          id="hrName"
                          name="hrName"
                          value={profileData.hrName}
                          className="form-control"
                          placeholder="Enter your HR's name"
                          disabled
                        />
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* Save Button */}
              <button
                type="button"
                onClick={handleSaveChanges}
                className="btn btn-success"
              >
                Save Changes
              </button>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MyProfile;
